// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"347":"210e018a","465":"7b0e883a"}[chunkId] + ".css";
};